import { atom } from 'jotai';

export const historyStackAtom = atom<
  {
    name?: string;
    afterAction?: () => void;
  }[]
>([]);
